import { render, staticRenderFns } from "./Payslip.vue?vue&type=template&id=8e4ce3a8&scoped=true&"
import script from "./Payslip.vue?vue&type=script&lang=js&"
export * from "./Payslip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e4ce3a8",
  null
  
)

export default component.exports